import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAPOOsGp1XQtVO3vKUBdbGijtA6TWafl3g",
    authDomain: "giftloop-468a3.firebaseapp.com",
    projectId: "giftloop-468a3",
    storageBucket: "giftloop-468a3.firebasestorage.app",
    messagingSenderId: "653634790649",
    appId: "1:653634790649:web:f959e940a7ab2c6d916e28"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);

